// extracted by mini-css-extract-plugin
export var ThreePanelMd4 = "AdditionalResources-module--ThreePanelMd4--zKlj6";
export var fivePanelMd4 = "AdditionalResources-module--fivePanelMd4--xbXsj";
export var largePanel = "AdditionalResources-module--largePanel--bqKTF";
export var md6 = "AdditionalResources-module--md6--Dcyuf";
export var multiPanel = "AdditionalResources-module--multiPanel--BKek9";
export var page404Title = "AdditionalResources-module--page404-title--wK959";
export var panel = "AdditionalResources-module--panel--mjEyP";
export var sectionHeader = "AdditionalResources-module--sectionHeader--TPssE";
export var topRow = "AdditionalResources-module--topRow--vAuCn";